import { render, staticRenderFns } from "./TaskProceduresTable.vue?vue&type=template&id=adfbf692"
import script from "./TaskProceduresTable.vue?vue&type=script&lang=ts"
export * from "./TaskProceduresTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports